import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from '../styles';

const Detail = ({ classes, title, value}) => {
  return (
    <div className={classes.rightPanelInfoSection} key={title}>
      <div className={classes.infoTitle}>{title}</div>
      <div className={`${classes.infoValue} ${classes.infoPadding}`}>{value ? value : ''}</div>
    </div>
  );
};

export default withStyles(styles)(Detail);
